module.exports = __webpack_public_path__ + "img/slide-instant-order-en.f85797f0.png";